import ConsumerRefService from "@api/consumer/consumerRefService";
import {EditGoalForm, GoalConditionsList, GoalRewardsList} from "@components/consumer/goals";
import withPage from "@components/hoc/withPage";
import {useBreadcrumbs, useStateLoader} from "@hooks/panelHooks";
import {IGoal} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {NavLink, Route, Routes, useParams} from "react-router";
import {Card, Nav, Row, Tab} from "react-bootstrap";
import {FormPageHeader} from "@components/falcon/common/forms";

const EditGoalPage: FC = () => {

    const {goal_id} = useParams<{ goal_id: string }>();
    const loadGoal = useCallback(() => {
        const api = new ConsumerRefService();
        return api.getGoal(goal_id || '');
    }, [goal_id]);

    const {data: goal} = useStateLoader<IGoal>(loadGoal);
    useBreadcrumbs('consumer.goals.current.name', false, goal?.name);

    if (!goal) {
        return null;
    }

    return (
        <>
            <Row className="g-3 m-0">
                <FormPageHeader title={`Редактирование достижения "${goal.name}"`} />
            </Row>
            <Tab.Container defaultActiveKey="basic">
                <Nav variant="tabs" className="mb-3">
                    <Nav.Item>
                        <NavLink to={`/consumer/goals/${goal_id}/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace end>
                            Основное
                        </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                        <NavLink to={`/consumer/goals/${goal_id}/conditions/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace>
                            Условия
                        </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                        <NavLink to={`/consumer/goals/${goal_id}/rewards/`} className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} replace>
                            Награды
                        </NavLink>
                    </Nav.Item>
                </Nav>
                <Routes>
                    <Route path="/" element={<EditGoalForm goal={goal} />} />
                    <Route path="conditions" element={<GoalConditionsList />} />
                    <Route path="rewards" element={<GoalRewardsList />} />
                </Routes>
            </Tab.Container>
        </>
    )
}

export default withPage(EditGoalPage);
